import React from 'react';

import PageHeader from './PageHeader';

const DocHeader = () => (
  <PageHeader>
    <p className="h1">Documentation</p>
    <p className="h2">Learn how Polypane improves your workflow</p>
  </PageHeader>
);

export default DocHeader;
